<app-grid>
  <app-info-area>
    <div [formGroup]="passPredictionForm">
      <div class="title mb-6">
        <h3 class="pb-4 text-primary text-xl dark:text-white font-bold">Pass Prediction</h3>
        <p class="info">Predict satellite passes for a given location and date. All fields are required
        </p>
      </div>

      <fieldset class="fieldset">
        <legend class="fieldset-legend">Start Date for 3 day prediction.</legend>
        <div class="flex mb-2">
          <label class="mr-3 flex items-center">
            <input formControlName="dateOption" type="radio" class="radio radio-xs mr-2" value="Today" (change)="updateDatePickerState()"/>
            <span>Today</span>
          </label>
          <label class="flex items-center">
            <input formControlName="dateOption" type="radio" class="radio radio-xs mr-2" value="Custom" (change)="updateDatePickerState()"/>
            <span>Custom date</span>
          </label>
        </div>
        <input formControlName="date" type="date" class="input">
      </fieldset>

      <fieldset class="fieldset mt-8">
        <legend class="fieldset-legend">Country</legend>
        <select class="select" formControlName="countryCode" >
          @for (country of countryList | async; track country.code) {
            <option value="{{country.code}}">{{country.name}}</option>
          }
        </select>
      </fieldset>

      <fieldset class="fieldset mt-8">
        <legend class="fieldset-legend">Satellite Service Type</legend>
        <div class="flex" formGroupName="serviceType">
          @for (service of serviceTypes; track service.id) {
            <label class="mr-3 flex">
              <input type="checkbox" [formControlName]="service.id" class="checkbox checkbox-xs"/>
              <div class="ml-2">{{service.name}}</div>
            </label>
          }
        </div>
      </fieldset>

      <fieldset class="fieldset mt-8">
        <legend class="fieldset-legend">Device Hardware Capability</legend>
        <div class="flex" formGroupName="hardwareCapability">
          @for (hw of hardwareCapabilities; track hw.id) {
            <label class="mr-3 flex">
              <input type="checkbox" [formControlName]="hw.id" class="checkbox checkbox-xs"/>
              <div class="ml-2">{{hw.name}}</div>
            </label>
          }
        </div>
      </fieldset>
      <fieldset class="fieldset mt-8" formGroupName="location">
        <legend class="fieldset-legend">Location</legend>
        <div class="flex">
          <div class="mr-6">
            <div>
              <label class="">Latitude (deg)</label>
            </div>
            <div>
              <input formControlName="latitude" type="text" class="input" />
            </div>
          </div>
          <div>
            <div>
              <label class="">Longitude (deg)</label>
            </div>
            <div>
              <input formControlName="longitude"  type="text" class="input" />
            </div>
          </div>
        </div>
        <button class="btn w-full" (click)="getUserLocation()">Get my location</button>
      </fieldset>
      <div>
        <button
          class="btn w-full btn-primary mt-8"
        (click)="submit()"> Get Passes </button>
      </div>
    </div>
  </app-info-area>
  <app-content-area>
    <h3 class="pb-4 text-primary text-xl font-bold dark:text-white">Predicted Passes</h3>
    <fieldset class="fieldset mb-4">
      <label class="flex items-center">
        <span class="mr-2">UTC</span>
        <input type="checkbox" class="toggle toggle-xs" [formControl]="passPredictionForm.controls.useLocalTime" (change)="createPassDataWithGroupHeaders()"/>
        <span class="ml-2">Local time ({{browserUtcOffset}})</span>
      </label>
    </fieldset>
    @if (passDataFromApi.length == 0){
      @if (passDataFromApi.length == 0) {
        <div class="no-passes-found mb-64">
          No passes predicted at this location during the next 3 days.
        </div>
      }
      }@else{
      <table class="w-full border-separate border-spacing-x-0 border-spacing-y-1">
        <thead>
          <tr>
            <th class="text-[10px] p-2 font-normal text-left">Start({{passPredictionForm.controls.useLocalTime.value ? browserUtcOffset : 'UTC'}})</th>
            <th class="text-[10px] p-2 font-normal text-left">TCA({{passPredictionForm.controls.useLocalTime.value ? browserUtcOffset : 'UTC'}})</th>
            <th class="text-[10px] p-2 font-normal text-left">End({{passPredictionForm.controls.useLocalTime.value ? browserUtcOffset : 'UTC'}})</th>
            <th class="text-[10px] p-2 font-normal text-left">Max Elevation</th>
            <th class="text-[10px] p-2 font-normal text-left">Satellite</th>
            <th class="text-[10px] p-2 font-normal text-left">Type</th>
          </tr>
        </thead>
        <tbody>
          @for (pass of passDataWithGroupHeaders; track pass) {
            @let almanacPass = $any(pass);
            @if (Object.hasOwn(almanacPass, 'groupName')){
              <tr class="bg-[#63E2BE] dark:bg-black">
                <td colspan="6" class="rounded-sm text-xs font-bold p-2 text-center  dark:border dark:border-[#63E2BE]">Passes with TCA on {{almanacPass.groupName}}</td>
              </tr>
              }@else{
              <tr class="bg-white dark:bg-black dark:text-white">
                <td class="dark:border-[#404040] text-xs p-2 font-bold border border-gray-300 border-r-0 rounded-l-sm">
                  <div class="font-light">{{extractDate(almanacPass.contact_start)}}</div>
                  <div>{{extractTime(almanacPass.contact_start)}}</div>
                </td>
                <td class="dark:border-[#404040] text-xs p-2 font-bold border border-gray-300 border-x-0">
                  <div class="font-light">{{extractDate(almanacPass.contact_tca)}}</div>
                  <div>{{extractTime(almanacPass.contact_tca)}}</div>
                </td>
                <td class="dark:border-[#404040] text-xs p-2 font-bold border border-gray-300 border-x-0">
                  <div class="font-light">{{extractDate(almanacPass.contact_end)}}</div>
                  <div>{{extractTime(almanacPass.contact_end)}}</div>
                </td>
                <td class="dark:border-[#404040] text-xs p-2 border border-gray-300 border-x-0 text-center">{{ almanacPass.max_elevation }}</td>
                <td class="dark:border-[#404040] text-xs p-2 border border-gray-300 border-x-0"><span class="cursor-help" title="lsm_id:{{almanacPass.satellite_id}}, norad_id:{{almanacPass.norad_id}}">{{ almanacPass.satellite }}</span></td>
                <td class="dark:border-[#404040] text-xs p-2 border border-gray-300 border-l-0 rounded-r-sm">{{ getServiceFromItsId(almanacPass.service) }}</td>
              </tr>
            }
          }
        </tbody>
      </table>
    }
  </app-content-area>
</app-grid>
